<script>
import compoment from '@/components/draggable/SmartComponents/basicComponents/SdataTime/SdataTimeEditor'
export default {
  name: 'SBirthdayEditor',
  extends: compoment
}
</script>
